// component
import { useParams } from 'react-router-dom';
import Iconify from '../../components/Iconify';
import LucideIcon from '../../components/LucideIcon';

// ----------------------------------------------------------------------


const getIcon = (name) => <LucideIcon name={name} />;



const navConfigOrg = [
  

  {
    title: 'Information',
    path: '/organisation/app',
    icon: 'Building2',
  },
  {
    title: 'CTT-Doors',
    path: '/organisation/door',
    icon: 'ScanLine',
  },
  {
    title: 'Espace de travail',
    icon: 'BriefcaseBusiness',
    children: [
      {
        title: 'Membres de l\'équipe',
        path: '/organisation/team',
      },
      {
        title: 'Gestion des roles',
        path: '/organisation/team/roles',
      },
    ],
  },
    
];

export default navConfigOrg;
